﻿// @ts-nocheck
// analytics: month/week/project/daily breakdowns

// ========== Analytics Functions ==========
function getMonthYear(timestamp) {
  const date = new Date(timestamp);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
}

function getWeekNumber(timestamp) {
  const date = new Date(timestamp);
  const start = new Date(date.getFullYear(), 0, 1);
  const diff = date - start;
  const oneday = 1000 * 60 * 60 * 24;
  return Math.floor(diff / oneday / 7) + 1;
}

function getMonthlySummary() {
  const byMonth = {};
  
  sessions.forEach((s) => {
    const month = getMonthYear(s.startTime);
    if (!byMonth[month]) {
      byMonth[month] = {
        hours: 0,
        earned: 0,
        projects: {},
        dayCount: 0,
      };
    }
    byMonth[month].hours += s.hours || 0;
    byMonth[month].earned += s.earned || 0;
    
    // Track projects
    const projectName = s.projectName || "Unknown";
    if (!byMonth[month].projects[projectName]) {
      byMonth[month].projects[projectName] = { hours: 0, earned: 0 };
    }
    byMonth[month].projects[projectName].hours += s.hours || 0;
    byMonth[month].projects[projectName].earned += s.earned || 0;
  });
  
  return byMonth;
}

function getWeeklyBreakdown(month) {
  const [year, monthNum] = month.split("-").map(Number);
  const byWeek = {};
  
  sessions.forEach((s) => {
    const date = new Date(s.startTime);
    if (date.getFullYear() === year && date.getMonth() + 1 === monthNum) {
      const week = getWeekNumber(s.startTime);
      const key = `Week ${week}`;
      if (!byWeek[key]) {
        byWeek[key] = { hours: 0, earned: 0, days: new Set(), sessions: 0 };
      }
      byWeek[key].hours += s.hours || 0;
      byWeek[key].earned += s.earned || 0;
      byWeek[key].days.add(new Date(s.startTime).toDateString());
      byWeek[key].sessions += 1;
    }
  });
  
  return byWeek;
}

function getProjectBreakdown(month) {
  const [year, monthNum] = month.split("-").map(Number);
  const byProject = {};
  
  sessions.forEach((s) => {
    const date = new Date(s.startTime);
    if (date.getFullYear() === year && date.getMonth() + 1 === monthNum) {
      const projectName = s.projectName || "Unknown";
      if (!byProject[projectName]) {
        byProject[projectName] = { hours: 0, earned: 0, rate: s.rate || 180, sessions: 0 };
      }
      byProject[projectName].hours += s.hours || 0;
      byProject[projectName].earned += s.earned || 0;
      byProject[projectName].sessions += 1;
    }
  });
  
  return byProject;
}

function getDailyBreakdown(month) {
  const [year, monthNum] = month.split("-").map(Number);
  const byDay = {};
  
  sessions.forEach((s) => {
    const date = new Date(s.startTime);
    if (date.getFullYear() === year && date.getMonth() + 1 === monthNum) {
      const dateStr = date.toISOString().split("T")[0];
      if (!byDay[dateStr]) {
        byDay[dateStr] = { hours: 0, earned: 0, sessions: 0 };
      }
      byDay[dateStr].hours += s.hours || 0;
      byDay[dateStr].earned += s.earned || 0;
      byDay[dateStr].sessions += 1;
    }
  });
  
  return byDay;
}
